// extracted by mini-css-extract-plugin
export default {"cardActions":"_1z4DRzPozoFlpnKo1V1Mhl","noTopPadding":"_3h74-gjtJI2CQUIZ97MPli","noVerticalPadding":"PUX-vSd8YroS4z7dXOh9o"};